import styled from 'styled-components';

import { BodilColor, NorlysColor, NorlysFont } from '~src/branding';
import { InputSize } from '~src/model';
import { calculateHoverColor } from '~src/util/color';

import { headingStyle } from '../Typography';

const sliderSize = (size: InputSize) => {
  switch (size) {
    case 'large':
      return '16px';
    case 'small':
      return '4px';
    case 'middle':
    default:
      return '8px';
  }
};

const thumpSize = (size: InputSize) => {
  switch (size) {
    case 'large':
      return '26px';
    case 'small':
      return '14px';
    case 'middle':
    default:
      return '18px';
  }
};

const resultSpacing = (size: InputSize) => {
  switch (size) {
    case 'large':
      return '8px 8px';
    case 'small':
      return '1.5px 8px';
    case 'middle':
    default:
      return '3px 8px';
  }
};

export const Wrapper = styled.div<{ size: InputSize; color: string }>(({ size, color }) => {
  const hoverColor = calculateHoverColor(color);

  return {
    width: '100%',
    '.ant-typography': {
      marginBottom: '4px',
      ...headingStyle(1),
    },
    '.ant-slider-rail': {
      backgroundColor: BodilColor.base.azure,
      height: sliderSize(size),
      borderRadius: sliderSize(size),
    },
    '.ant-slider:hover .ant-slider-rail': {
      backgroundColor: BodilColor.base.azure,
    },
    '.ant-slider-track': {
      backgroundColor: color,
      height: sliderSize(size),
      borderRadius: sliderSize(size),
    },
    '.ant-slider:hover .ant-slider-track': {
      backgroundColor: hoverColor,
    },
    '.ant-slider-handle': {
      border: `solid 2px ${color}`,
      width: thumpSize(size),
      height: thumpSize(size),
      '&:focus': {
        boxShadow: `0 0 0 3px ${hoverColor}80`,
      },
    },
    '.ant-slider:hover:focus .ant-slider-handle': {
      border: `solid 2px ${hoverColor}`,
    },
    '.ant-slider:hover .ant-slider-handle:not(.ant-tooltip-open)': {
      borderColor: hoverColor,
    },
    '.ant-slider-handle.ant-tooltip-open': {
      borderColor: color,
    },
    '.ant-slider-handle:focus': {
      borderColor: color,
    },
  };
});

export const WrapperNorlys = styled.div<{ size: InputSize }>(({ size }) => {
  return {
    width: '100%',
    '.ant-typography': {
      marginBottom: '4px',
      ...NorlysFont.style('default', 14),
    },
    '.ant-slider-rail': {
      backgroundColor: NorlysColor.secondary.lightPurple,
      height: sliderSize(size),
      borderRadius: sliderSize(size),
    },
    '.ant-slider:hover .ant-slider-rail': {
      backgroundColor: NorlysColor.secondary.lightPurple,
    },
    '.ant-slider-track': {
      backgroundColor: NorlysColor.secondary.purple,
      height: sliderSize(size),
      borderRadius: sliderSize(size),
    },
    '.ant-slider:hover .ant-slider-track': {
      backgroundColor: NorlysColor.secondary.purple,
    },
    '.ant-slider-handle': {
      border: `solid 2px ${NorlysColor.secondary.purple}`,
      width: thumpSize(size),
      height: thumpSize(size),
      '&:focus': {
        boxShadow: `0 0 0 3px ${NorlysColor.secondary.purple}80`,
      },
    },
    '.ant-slider:hover:focus .ant-slider-handle': {
      border: `solid 2px ${NorlysColor.secondary.purple}`,
    },
    '.ant-slider:hover .ant-slider-handle:not(.ant-tooltip-open)': {
      borderColor: NorlysColor.secondary.purple,
    },
  };
});

export const Result = styled.div({
  display: 'flex',
  alignItems: 'center',
  ...headingStyle(1),
  fontWeight: 600,
  userSelect: 'none',
  color: BodilColor.greyscale['00'],
});

export const ResultWrapper = styled.div<{ size: InputSize }>(({ size }) => {
  return {
    margin: resultSpacing(size),
  };
});

export const TopRow = styled.div({
  display: 'flex',
  flexFlow: 'row nowrap',
  alignItems: 'center',
  justifyContent: 'space-between',
});

export const BottomRow = styled.div({
  display: 'flex',
  flexFlow: 'row nowrap',
  width: `100%`,
});
